import Image, { ImageProps } from 'next/image'
import { CSSProperties } from 'react'

import styles from './CircleAvatar.module.css'

export type CircleAvatarProps = Omit<ImageProps, 'src' | 'alt'> & {
  padding?: number
  size?: number
  src?: string | null
  withBorder?: boolean
  alt?: string
}

export const CircleAvatar = ({
  padding = 0,
  size = 50,
  withBorder = false,
  src,
  alt = 'avatar',
  ...props
}: CircleAvatarProps) => (
  <span
    className={styles.circleAvatar}
    style={
      {
        '--size': `${size}px`,
        '--border': withBorder ? '1px' : '0',
        '--padding': `${padding}px`,
      } as CSSProperties
    }
  >
    {src?.startsWith('http') && <Image alt={alt} {...props} src={src} width={size} height={size} />}
  </span>
)
